import React, { useState } from "react";
import { Row, Col } from "antd";
import useIsMobile from "../../../../hooks/useIsMobile";
import PatientDetails from "./PatientDetails";
import AssignPackages from "./AssignPackages";
import styles from "./PackagesIp.module.css";

const PACKAGES_TABS = [
  { value: "package", label: "Package" },
  { value: "patient", label: "Patient Info" },
];

const PackagesIp = ({ patientData }) => {
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState("package");

  return (
    <div className={styles.packagesPage}>
      {isMobile && (
        <div className={styles.packagesMobileToggle} role="tablist" aria-label="Packages view">
          {PACKAGES_TABS.map((tab) => (
            <button
              key={tab.value}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.value}
              className={`${styles.packagesSegmentBtn} ${
                activeTab === tab.value ? styles.packagesSegmentBtnActive : ""
              }`}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}

      <Row gutter={[12, 12]} className={styles.packagesRow}>
        <Col
          xs={24}
          lg={12}
          xl={12}
          className={
            isMobile && activeTab !== "patient" ? styles.packagesPanelHidden : ""
          }
        >
          <PatientDetails />
        </Col>
        <Col
          xs={24}
          lg={12}
          xl={12}
          className={
            isMobile && activeTab !== "package" ? styles.packagesPanelHidden : ""
          }
        >
          <AssignPackages patientData={patientData} />
        </Col>
      </Row>
    </div>
  );
};

export default PackagesIp;
